import React, { useMemo } from "react";
//  @ts-ignore
import cardUtils from "@fdr-mar/utils/cardSlotUtils";
import { CardSlot } from "@fdr-mar/promos-types/Component";
import { Header } from "@tvg/design-system/web";
import { useFormation } from "@urp/amplitude-experiments";
import PromoSlotsFormation from "@urp/formation-promos-page";
import Slot from "../Slot";
import {
  PromoSlotsContainer,
  PromoSlotsWrapper,
  HeaderContainer
} from "./styled-components";

type Content = {
  header: string;
  slots: CardSlot[];
};

type Props = {
  content: Content;
};

/* eslint-disable no-underscore-dangle */

const PromoSlots: React.FC<Props> = ({ content }) => {
  const isFormationActive = useFormation();

  const renderSlots = (slots: CardSlot[]) => {
    const tabletLastRowCardsIndex = cardUtils.detectCardsLastRow(
      slots.length,
      2
    );
    const desktopLastRowCardsIndex = cardUtils.detectCardsLastRow(
      slots.length,
      3
    );

    return slots.map((slot, index) => (
      <Slot
        key={slot._uid}
        isTopPromo
        content={slot}
        position={index + 1}
        className={`
          ${index > tabletLastRowCardsIndex ? "tabletLastRow" : ""} 
          ${index > desktopLastRowCardsIndex ? "desktopLastRow" : ""}
        `}
      />
    ));
  };

  const slots = useMemo(() => renderSlots(content.slots), [content.slots]);

  return (
    <>
      {isFormationActive ? (
        <PromoSlotsFormation content={content} />
      ) : (
        <>
          <HeaderContainer>
            <Header
              tag="h1"
              qaLabel="promo-title"
              fontFamily="bold"
              color="--fd-colors-content-strong"
              fontSize="var(--fd-font-sizes-heading-medium)"
              lineHeight="24px"
            >
              {content.header}
            </Header>
          </HeaderContainer>
          <PromoSlotsWrapper>
            <PromoSlotsContainer data-qa-label="promoSlotsContainer">
              {slots}
            </PromoSlotsContainer>
          </PromoSlotsWrapper>
        </>
      )}
    </>
  );
};

export default PromoSlots;
